import React from "react";
import Img from "gatsby-image";
import get from "lodash/get";

const ContentfulImg = ({ img, width, height }) => {
  const { title, file } = img;
  const fixed = get(img, "fixed");
  const fluid = get(img, "fluid");
  const url = get(file, "url");
  const _width = width ? width : get(file, `details.image.width`);
  const _height = height ? height : get(file, `details.image.height`);
  return fluid || fixed ? (
    <Img fixed={fixed} fluid={fluid} alt={title} style={{ maxWidth: "100%" }} />
  ) : (
    <img
      src={url}
      width={_width}
      height={_height}
      alt={title}
      style={{ maxWidth: "100%" }}
    />
  );
};

export default ContentfulImg;
